
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/menu/[name]",
      function () {
        return require("private-next-pages/menu/[name]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/menu/[name]"])
      });
    }
  